module.exports = __webpack_public_path__ + "static/media/jerky.08549535.webp";